import './App.css';
import Map from './pages/Map';
import {
  BrowserRouter,
  Route,
  Routes,
} from "react-router-dom";

import Authenticated from './Layouts/Authenticated';
import Login from './pages/Login';
import Markers from './pages/Markers/Markers';
import Instructions from './pages/Instructions';
import Tork from './pages/Tork/Tork';
import TorkPlanning from './pages/TorkPlanning/TorkPlanning';
import UserRoles from './pages/Admin/UserRoles';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/map" element={<Authenticated><Map /></Authenticated>} />
        <Route path="/markers" element={<Authenticated><Markers /></Authenticated>} />
        <Route path="/tork" element={<Authenticated><Tork /></Authenticated>} />
        <Route path="/torkplanering" element={<Authenticated><TorkPlanning /></Authenticated>} />
        <Route path="/instructions" element={<Authenticated><Instructions /></Authenticated>} />
        <Route path="/admin/user-roles" element={<Authenticated><UserRoles /></Authenticated>} />
      </Routes>
    </BrowserRouter>
  );

}


export default App;
